export const customProperties = 'react-scrolling-background__vars';
export const image = 'react-scrolling-background__image';
export const root = 'react-scrolling-background';
